export const retirarMascaraCnpj = (valor) => {
    const cnpj = valor;
    const cnpjSemMascara = cnpj.replace(/[^\d]/g, '');

    return cnpjSemMascara;
};

export const retirarMascaraGeral = (valor) => {
    const valorSemMascara = valor.replace(/[^a-zA-Z0-9]/g, '').trim();
    return valorSemMascara;
};

export const retirarMascaraPesquisaCliente = (valor) => {
    const texto = (valor ?? '').toString().trim();
    const temLetra = /[a-zA-Z]/.test(texto);

    if (temLetra) {
        return texto
            .replace(/[^a-zA-Z0-9\s]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    }

    return texto.replace(/[^0-9]/g, '').trim();
};